import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowTopRightFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.62 16.94L15.18 7.36H7.34V5.52H18.38V16.56H16.54V8.68L6.96 18.28L5.62 16.94Z" />
    </SvgIcon>
  );
});
